import { render, staticRenderFns } from "./WorkMenu.vue?vue&type=template&id=31afbf8b&scoped=true"
import script from "./WorkMenu.vue?vue&type=script&lang=js"
export * from "./WorkMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkMenu.vue?vue&type=style&index=0&id=31afbf8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31afbf8b",
  null
  
)

export default component.exports